import { useOperatorsOrdersQuery } from 'api/queries/operators';
import { useUsersCurrentAccessesQuery } from 'api/queries/users';
import dayjs from 'dayjs';
import { LegSchemaType, UserPermission } from 'remote/global';
import OrderEditModal from './OrderEditModal';

type WrappedOrderDetailsModalProps = {
  open: boolean;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  bookingNumber: string;
  rideNumber: number;
};

const getIsLastLegDateValid = (legs: LegSchemaType[]) => {
  if (!legs || legs?.length <= 0) return false;

  const lastLeg = legs[legs.length - 1];
  if (!lastLeg) return false;
  if (dayjs(new Date()) > dayjs(lastLeg.endTime)) return false;
  return true;
};

export function useOrderEditStatus({
  bookingNumber,
  rideNumber,
}: {
  bookingNumber: string;
  rideNumber: number;
}) {
  const { data: userInfo } = useUsersCurrentAccessesQuery();
  const { data: order } = useOperatorsOrdersQuery(bookingNumber);

  const { permissions = {} } = userInfo ?? {};
  const hasOrderEditPermissions =
    permissions.ORDER === UserPermission.WRITE_OWN ||
    permissions.ORDER === UserPermission.WRITE_ALL;

  const isOrderCancelled = order?.cancelledAt != null; // cancelledAt will only be available when order is cancelled
  const selectedRide = order?.rides.find((ride) => ride.rideNumber === rideNumber);
  const isLastLegDateValid = getIsLastLegDateValid(selectedRide?.legs ?? []);
  const isOrderEditAvailable = hasOrderEditPermissions && !isOrderCancelled && isLastLegDateValid;
  const isEditDisabled = !isLastLegDateValid;

  return { isOrderEditAvailable, isOrderCancelled, isEditDisabled };
}

function WrappedOrderDetailsModal({
  open,
  setOpen,
  onClose,
  bookingNumber,
  rideNumber,
}: WrappedOrderDetailsModalProps) {
  const { isOrderEditAvailable } = useOrderEditStatus({ bookingNumber, rideNumber });

  return (
    <OrderEditModal
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      bookingNumber={bookingNumber}
      isOrderEditAvailable={isOrderEditAvailable}
      rideNumber={rideNumber}
    />
  );

  /* return (
    <OrderDetailsModal
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      orderQuery={orderQuery}
      rideNumber={rideNumber}
      header={{
        children: orderQuery.isSuccess ? (
          <>
            <Button type='button' onClick={() => setIsEditOrderOpen((p) => !p)}>
              {isOrderEditAvailable ? t('edit') : t('terms.attributes.details')}
            </Button>
            <OrderEditModal
              open={isEditOrderOpen}
              setOpen={setIsEditOrderOpen}
              onClose={() => setIsEditOrderOpen(false)}
              bookingNumber={bookingNumber}
              isOrderEditAvailable={isOrderEditAvailable}
              rideNumber={rideNumber}
            />
          </>
        ) : null,
      }}
      endSlot={<OrderDetailsEditCarrier bookingNumber={bookingNumber} rideNumber={rideNumber} />}
    />
  ); */
}

export default WrappedOrderDetailsModal;
